import { jsxs, jsx } from "react/jsx-runtime";
import { Dialog, Button } from "@graphiql/react";
import { collectionsStore } from "../store.js";
const ExportDialog = ({ open, onClose }) => {
  const exported = open ? collectionsStore.getState().actions.exportCollections() : "";
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(exported);
    } catch {
      return;
    }
    onClose();
  };
  const handleDownload = () => {
    const blob = new Blob([exported], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "graphiql-collections.json";
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 0);
    onClose();
  };
  return /* @__PURE__ */ jsxs(Dialog, { open, onOpenChange: (o) => !o && onClose(), children: [
    /* @__PURE__ */ jsx(Dialog.Header, { children: "Export collections" }),
    /* @__PURE__ */ jsx(Dialog.Body, { children: /* @__PURE__ */ jsxs("div", { className: "graphiql-import-export-section", children: [
      /* @__PURE__ */ jsx(
        "textarea",
        {
          readOnly: true,
          className: "graphiql-import-export-textarea",
          value: exported,
          rows: 12
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: "graphiql-import-export-actions", children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            type: "button",
            variant: "primary",
            onClick: () => void handleCopy(),
            children: "Copy JSON"
          }
        ),
        /* @__PURE__ */ jsx(Button, { type: "button", onClick: handleDownload, children: "Download JSON" })
      ] })
    ] }) })
  ] });
};
export {
  ExportDialog
};
//# sourceMappingURL=export-dialog.js.map
